/**
 * Scrolling Images Section JavaScript
 * Handles the manual scrolling functionality when enabled
 * Supports click-and-drag scrolling behavior
 */
document.addEventListener('DOMContentLoaded', function() {
  // Find all scrolling images sections
  const scrollingSections = document.querySelectorAll('.scrolling-images');
  
  scrollingSections.forEach(section => {
    // Check if manual scrolling is enabled
    const manualScrollEnabled = section.dataset.manualScroll === 'true';
    
    if (!manualScrollEnabled) {
      return; // Skip this section if manual scrolling is not enabled
    }
    
    const container = section.querySelector('.scrolling-images--container');
    const prevButton = section.querySelector('.scrolling-images--nav-button.prev');
    const nextButton = section.querySelector('.scrolling-images--nav-button.next');
    const items = section.querySelectorAll('.scrolling-images--item');
    
    if (!container || !prevButton || !nextButton || !items.length) {
      return; // Skip if required elements are not found
    }
    
    // Variables to track scrolling state
    let currentIndex = 0;
    let itemWidth = 0;
    let containerWidth = 0;
    let maxScroll = 0;
    let isMouseDown = false;
    let startX = 0;
    let scrollLeft = 0;
    let currentTranslate = 0;
    
    // Initialize measurements
    function initMeasurements() {
      if (items.length === 0) return;
      
      // Get the width of the first item including margins
      const firstItem = items[0];
      const style = window.getComputedStyle(firstItem);
      const marginLeft = parseFloat(style.marginLeft);
      const marginRight = parseFloat(style.marginRight);
      
      itemWidth = firstItem.offsetWidth + marginLeft + marginRight;
      containerWidth = container.parentElement.offsetWidth;
      
      // Calculate the maximum scroll distance
      const totalItemsWidth = items.length * itemWidth;
      maxScroll = Math.max(0, totalItemsWidth - containerWidth);
      
      // Update button states
      updateButtonStates();
    }
    
    // Update the prev/next button states
    function updateButtonStates() {
      // Disable prev button if at the beginning
      const isAtStart = currentTranslate >= 0;
      prevButton.disabled = isAtStart;
      prevButton.style.opacity = isAtStart ? '0.5' : '1';
      
      // Disable next button if at the end
      const isAtEnd = Math.abs(currentTranslate) >= maxScroll - 5; // 5px threshold for floating point issues
      nextButton.disabled = isAtEnd;
      nextButton.style.opacity = isAtEnd ? '0.5' : '1';
    }
    
    // Handler for the previous button
    prevButton.addEventListener('click', function() {
      scrollByAmount(containerWidth * 0.8); // Scroll by 80% of container width
    });
    
    // Handler for the next button
    nextButton.addEventListener('click', function() {
      scrollByAmount(-containerWidth * 0.8); // Scroll by 80% of container width
    });
    
    // Scroll by a specific amount
    function scrollByAmount(amount) {
      // Calculate new translate position
      let newTranslate = currentTranslate + amount;
      
      // Apply boundaries
      if (newTranslate > 0) {
        newTranslate = 0;
      } else if (newTranslate < -maxScroll) {
        newTranslate = -maxScroll;
      }
      
      // Apply the transform with smooth transition
      container.style.transition = 'transform 0.3s ease-out';
      container.style.transform = `translateX(${newTranslate}px)`;
      currentTranslate = newTranslate;
      
      // Update button states
      updateButtonStates();
    }
    
    // Mouse down event - start dragging
    function handleMouseDown(e) {
      // Only handle left mouse button (button === 0)
      if (e.type === 'mousedown' && e.button !== 0) return;
      
      isMouseDown = true;
      container.classList.add('is-dragging');
      
      // Get the starting position
      startX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
      
      // Get the current scroll position
      const transformMatrix = window.getComputedStyle(container).transform;
      const matrix = new DOMMatrixReadOnly(transformMatrix);
      currentTranslate = matrix.m41; // This gets the translateX value
      
      // Remove transition during drag
      container.style.transition = 'none';
      
      // Prevent default behavior like text selection
      e.preventDefault();
    }
    
    // Mouse move event - drag the carousel
    function handleMouseMove(e) {
      if (!isMouseDown) return;
      
      // Get current mouse position
      const x = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
      const walkX = x - startX;
      
      // Calculate new position
      let newTranslate = currentTranslate + walkX;
      
      // Apply resistance at boundaries for better feel
      if (newTranslate > 0) {
        // Start of carousel - apply resistance
        newTranslate = newTranslate * 0.3;
      } else if (newTranslate < -maxScroll) {
        // End of carousel - apply resistance
        const overscrollAmount = newTranslate + maxScroll;
        newTranslate = -maxScroll + (overscrollAmount * 0.3);
      }
      
      // Apply the transform
      container.style.transform = `translateX(${newTranslate}px)`;
      
      // Prevent default to avoid text selection, etc
      e.preventDefault();
    }
    
    // Mouse up event - stop dragging
    function handleMouseUp(e) {
      if (!isMouseDown) return;
      
      isMouseDown = false;
      container.classList.remove('is-dragging');
      
      // Get final mouse position to determine direction and speed
      const x = e.type === 'touchend' ? 
        (e.changedTouches[0] ? e.changedTouches[0].clientX : startX) : 
        e.clientX;
      const walkX = x - startX;
      
      // Add smooth transition for snapping
      container.style.transition = 'transform 0.3s ease-out';
      
      // Get the current position
      const transformMatrix = window.getComputedStyle(container).transform;
      const matrix = new DOMMatrixReadOnly(transformMatrix);
      currentTranslate = matrix.m41;
      
      // Apply boundaries with snap
      if (currentTranslate > 0) {
        // Snapped to start
        container.style.transform = 'translateX(0)';
        currentTranslate = 0;
      } else if (currentTranslate < -maxScroll) {
        // Snapped to end
        container.style.transform = `translateX(${-maxScroll}px)`;
        currentTranslate = -maxScroll;
      } else if (Math.abs(walkX) > 100) {
        // If it was a significant swipe, move to next/prev item
        const direction = walkX > 0 ? 1 : -1; // 1 for right, -1 for left
        scrollByAmount(direction * containerWidth * 0.8);
      } else {
        // Otherwise snap to closest item
        const closestItemIndex = Math.round(Math.abs(currentTranslate) / itemWidth);
        const targetTranslate = -closestItemIndex * itemWidth;
        
        // Don't exceed boundaries
        if (targetTranslate < -maxScroll) {
          container.style.transform = `translateX(${-maxScroll}px)`;
          currentTranslate = -maxScroll;
        } else {
          container.style.transform = `translateX(${targetTranslate}px)`;
          currentTranslate = targetTranslate;
        }
      }
      
      // Update button states
      updateButtonStates();
    }
    
    // Cancel dragging if mouse leaves the window
    function handleMouseLeave() {
      if (isMouseDown) {
        handleMouseUp({ clientX: startX }); // Simulate a mouse up at the start position
      }
    }
    
    // Handle clicks on links
    function handleClick(e) {
      // If we were dragging, prevent link clicks
      if (container.classList.contains('was-dragging')) {
        e.preventDefault();
        e.stopPropagation();
        container.classList.remove('was-dragging');
      }
    }
    
    // Reset was-dragging class after a delay
    function resetDraggingState() {
      if (container.classList.contains('was-dragging')) {
        setTimeout(() => {
          container.classList.remove('was-dragging');
        }, 50);
      }
    }
    
    // Mouse and touch event listeners
    container.addEventListener('mousedown', handleMouseDown);
    container.addEventListener('touchstart', handleMouseDown, { passive: false });
    
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('touchmove', handleMouseMove, { passive: false });
    
    window.addEventListener('mouseup', handleMouseUp);
    window.addEventListener('touchend', handleMouseUp);
    window.addEventListener('mouseleave', handleMouseLeave);
    
    // Handle clicks within the container
    container.addEventListener('click', handleClick, true);
    document.addEventListener('click', resetDraggingState);
    
    // Prevent context menu on right click
    container.addEventListener('contextmenu', e => e.preventDefault());
    
    // Handle transition end
    container.addEventListener('transitionend', function() {
      // Get current translate value
      const transformMatrix = window.getComputedStyle(container).transform;
      const matrix = new DOMMatrixReadOnly(transformMatrix);
      currentTranslate = matrix.m41;
      
      // Update buttons after transition completes
      updateButtonStates();
    });
    
    // Initialize on page load
    initMeasurements();
    
    // Handle window resize with debounce
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        // Save current scroll position as percentage
        const scrollPercentage = maxScroll > 0 ? Math.abs(currentTranslate) / maxScroll : 0;
        
        // Recalculate dimensions
        initMeasurements();
        
        // Apply new scroll position based on percentage
        if (maxScroll > 0) {
          const newTranslate = -scrollPercentage * maxScroll;
          container.style.transition = 'none';
          container.style.transform = `translateX(${newTranslate}px)`;
          currentTranslate = newTranslate;
          
          // Force reflow
          container.offsetHeight;
          
          // Restore transition
          container.style.transition = 'transform 0.3s ease-out';
        }
      }, 250);
    });
  });
});